import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { TOOLS, CATEGORIES } from './registry';
import './ui/tools.css';
import '../styles.css';

function ToolTile({ tool, onOpen }) {
  return (
    <button type="button" className="tool-tile" onClick={onOpen}>
      {tool.image ? (
        <div className="tool-tile-img" style={{ backgroundImage: `url(/images/${tool.image})` }} />
      ) : (
        <div className="tool-tile-img tool-tile-img--generated">
          <span className="material-icons">{tool.icon || 'build'}</span>
        </div>
      )}
      <div className="tool-tile-body">
        <div className="tool-tile-name">
          {tool.name}
          {tool.tag && <span className="tool-tile-tag">{tool.tag}</span>}
        </div>
        <div className="tool-tile-desc">{tool.description}</div>
      </div>
    </button>
  );
}

function ToolsHub() {
  const navigate = useNavigate();
  const groups = CATEGORIES
    .map((c) => ({ c, tools: TOOLS.filter((t) => t.category === c) }))
    .filter((g) => g.tools.length);

  return (
    <div>
      <Header />
      <div className="tools-scope tool-page">
        <div className="tool-page-inner">
          <div className="page-title">
            <h1>Tools</h1>
            <button onClick={() => navigate('/')} className="close-button">✕</button>
          </div>
          {groups.map(({ c, tools }) => (
            <React.Fragment key={c}>
              <div className="tools-section-title">{c}</div>
              <div className="tools-grid">
                {tools.map((t) => (
                  <ToolTile key={t.id} tool={t} onOpen={() => navigate(`/tools/${t.id}`)} />
                ))}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ToolsHub;
